import { clsx } from 'clsx'
import styles from './Skeleton.module.css'

type SkeletonProps = {
  /** Any CSS length. Defaults to filling the parent. */
  width?: string
  height?: string
  /** Text-height block that inherits the surrounding font size. */
  isText?: boolean
  className?: string | undefined
}

export function Skeleton({ width, height, isText = false, className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={clsx(styles.skeleton, isText && styles.isText, className)}
      style={{
        ...(width !== undefined ? { width } : {}),
        ...(height !== undefined ? { height } : {}),
      }}
    />
  )
}

type SkeletonTextProps = {
  /** Number of lines. The last one runs short, as real text does. */
  lines?: number
  className?: string | undefined
}

export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <span className={clsx(styles.lines, className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} isText />
      ))}
    </span>
  )
}
